import {
  USERS_LIST,
  USERS_LIST_SUCCESS,
  USERS_LIST_ERROR,
  USERS_NEW,
  USERS_NEW_SUCCESS,
  USERS_NEW_ERROR,
  USERS_EDIT,
  USERS_DELETE,
  USERS_DELETE_SUCCESS,
  USERS_DELETE_ERROR,
  USERS_BLOCK,
  USERS_BLOCK_SUCCESS,
  USERS_BLOCK_ERROR,
} from "./actionTypes"


export const usersList = data => ({
  type: USERS_LIST,
  payload: data
});

export const usersListSuccess = data => ({
  type: USERS_LIST_SUCCESS,
  payload: {data}
});

export const usersListError = error => ({
  type: USERS_LIST_ERROR,
  payload: error,
});

export const usersNew = data => ({
  type: USERS_NEW,
  payload: data
});

export const usersNewSuccess = data => ({
  type: USERS_NEW_SUCCESS,
  payload: {data}
});

export const usersNewError = error => ({
  type: USERS_NEW_ERROR,
  payload: error,
});

export const usersEdit = data => ({
  type: USERS_EDIT,
  payload: data
});

export const usersDelete = data => ({
  type: USERS_DELETE,
  payload: data
});

export const usersDeleteSuccess = data => ({
  type: USERS_DELETE_SUCCESS,
  payload: {data}
});

export const usersDeleteError = error => ({
  type: USERS_DELETE_ERROR,
  payload: error,
});

export const usersBlock = data => ({
  type: USERS_BLOCK,
  payload: data
});

export const usersBlockSuccess = data => ({
  type: USERS_BLOCK_SUCCESS,
  payload: {data}
});

export const usersBlockError = error => ({
  type: USERS_BLOCK_ERROR,
  payload: error,
});
